import eachDeep from 'deepdash/eachDeep';

const getErrorMessages = fieldInfo => {
	const validationErrors = [];
	eachDeep(fieldInfo, value => {
		if (typeof value.isValid !== 'undefined' && value.isValid === false) {
			validationErrors.push({ label: value.label, errorMessages: value.errorMessages });
		}
	});
	return validationErrors;
};

export default getErrorMessages;
